import { Avatar, AvatarProps } from 'antd';

type InquiryAvatarProps = {
  text?: string
} & AvatarProps;

const InquiryAvatar: React.FC<InquiryAvatarProps> = (props) => {
  return (
    <Avatar
      style={{ backgroundColor: '#3F86FF' }}
      shape="square"
      size={48}
      {...props}
    >
      {
        !props.icon &&
        <span style={{ fontSize: 16 }}>{props.text?.slice(-2)}</span>
      }
    </Avatar>
  )
};

export default InquiryAvatar;
